import {
  ArrowRightOutlined,
  CheckCircleOutlined,
  EditOutlined,
  ExclamationCircleOutlined,
} from '@ant-design/icons';
import { Button, Input, Modal, Table, Tag } from 'antd';
import moment from 'moment';
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';
import DetailsDrawer from '../../components/ui/DetailsDrawer';
import PageHeader from '../../components/ui/PageHeader';
import { getData, postData } from '../../config/api-connect';
import { formatCurrency } from '../../utils/helper';
import './collectionList.css';
import CollectionToolbar from './collectionToorBar';

const { TextArea } = Input;

function CollectionVerification() {
  const location = useLocation();
  const inputRef = useRef(null);

  const [venueId, setVenueId] = useState();
  const [month, setMonth] = useState();
  const [year, setYear] = useState();

  const [collectionData, setCollectionData] = useState([]);
  const [venueName, setVenueName] = useState('');

  const [tableLoader, setTableLoader] = useState(false);
  const [filterOptions, setFilterOptions] = useState([]);
  const [appliedFilters, setAppliedFilters] = useState([['status', 'not verified']]);
  const [sortSelector, setSortSelector] = useState('newest first');
  const [mobileNumber, setMobileNumber] = useState('');

  const [tablePage, setTablePage] = useState(1);
  // const [tableTotalPages, setTableTotalPages] = useState(0);
  const [tablePageSize, setTablePageSize] = useState(25);
  const [totalEntries, setTotalEntries] = useState(0);

  const [openDrawer, setOpenDrawer] = useState(false);
  const [selectedTableRow, setSelectedTableRow] = useState([]);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [hasSearched, setHasSearched] = useState(false);

  const [editedTransactionID, setEditedTransactionID] = useState('');
  const [updateTransactionIDLoader, setUpdateTransactionIDLoader] = useState(false);

  const [matchingPayments, setMatchingPayments] = useState([]);
  const [loader, setLoader] = useState(false);

  const [logsModalOpen, setLogsModalOpen] = useState(false);
  const [logsLoading, setLogsLoading] = useState(false);
  const [logsData, setLogsData] = useState([]);

  const logsColumns = [
    {
      title: 'Edited Date',
      dataIndex: 'edited_date',
      key: 'edited_date',
      onHeaderCell: () => ({ className: 'collist-header-cell' }),
    },
    {
      title: 'Type',
      dataIndex: 'change_type',
      key: 'change_type',
      onHeaderCell: () => ({ className: 'collist-header-cell' }),
    },
    {
      title: 'Changes',
      dataIndex: 'changes',
      key: 'changes',
      onHeaderCell: () => ({ className: 'collist-header-cell' }),
    },
    {
      title: 'Concerned Person',
      dataIndex: 'concerned_person',
      key: 'concerned_person',
      onHeaderCell: () => ({ className: 'collist-header-cell' }),
    },
    {
      title: 'Reason',
      dataIndex: 'reason',
      key: 'reason',
      onHeaderCell: () => ({ className: 'collist-header-cell' }),
    },
    {
      title: 'Edited By',
      dataIndex: 'changed_by',
      key: 'changed_by',
      onHeaderCell: () => ({ className: 'collist-header-cell' }),
    },
  ];

  const formatted = moment(`${year}-${month}`, 'YYYY-MM').format('MMMM YYYY');

  useEffect(() => {
    const params = new URLSearchParams(location.search);

    setVenueId(params.get('venue_id'));
    setMonth(params.get('month'));
    setYear(params.get('year'));
  }, [location.search]);

  useEffect(() => {
    if (isModalOpen) {
      setTimeout(() => {
        inputRef.current?.focus();
      }, 100);
    }
  }, [isModalOpen]);

  const get_venue_wise_collection_data = useCallback(
    async (page = 1, number = '') => {
      setTableLoader(true);

      try {
        const asc = sortSelector === 'oldest first';

        const response = await postData('/finance/get_venue_wise_collection_data/', {
          venue_id: venueId,
          month: month,
          year: year,
          filters: appliedFilters,
          page: page,
          phone_number: number,
          asc: asc,
        });

        setCollectionData(response.result);
        getFilterValues(response);
        // setTableTotalPages(response.num_pages);
        setTablePageSize(response.pageSize);
        setTotalEntries(response.total_entries);
        setVenueName(response.venue_name);
      } catch (error) {
        console.log(error.message);
      } finally {
        setTableLoader(false);
      }
    },
    [venueId, month, year, sortSelector, appliedFilters],
  );

  useEffect(() => {
    if (venueId && month && year) {
      get_venue_wise_collection_data(1);
    }
  }, [venueId, month, year, sortSelector, appliedFilters, get_venue_wise_collection_data]);

  const handleViewLogs = async () => {
    const subId = selectedTableRow?.subscription?.id;
    if (!subId) {
      setLogsData([]);
      setLogsModalOpen(true);
      return;
    }
    setLogsLoading(true);
    setLogsModalOpen(true);
    try {
      const response = await getData(
        `/customer_list/get_subscription_change_logs/?sub_id=${subId}`,
      );
      setLogsData(response.change_logs || []);
    } catch (error) {
      setLogsData([]);
    } finally {
      setLogsLoading(false);
    }
  };

  const getFilterValues = (data) => {
    var status_list = data.filter_status;
    var paymentmode_list = data.filter_payment_modes;

    status_list = [...new Set(status_list)];
    paymentmode_list = [...new Set(paymentmode_list)];

    var status_data = [];
    for (var i = 0; i < status_list.length; i++) {
      status_data.push({ label: status_list[i], value: status_list[i] });
    }

    var mode_data = [];
    for (var j = 0; j < paymentmode_list.length; j++) {
      if (paymentmode_list[j]) {
        mode_data.push({ label: paymentmode_list[j], value: paymentmode_list[j] });
      }
    }

    mode_data = [...new Set(mode_data)];
    status_data = [...new Set(status_data)];

    var filter_options = [
      { value: 'status', label: 'Status', children: status_data },
      { value: 'payment_mode', label: 'Payment Mode', children: mode_data },
    ];
    setFilterOptions(filter_options);
  };

  const onChangePage = async (page) => {
    setTablePage(page.current);
    get_venue_wise_collection_data(page.current);
  };

  const filterCascader = (inputValue, path) => {
    if (!inputValue) return true;
    return path.some((option) => {
      const label = option && option.label;
      return (
        typeof label === 'string' && label.toLowerCase().indexOf(inputValue.toLowerCase()) > -1
      );
    });
  };

  const onChangeFilter = (value) => {
    setAppliedFilters(value);
    if ((!value || value.length === 0) && value === appliedFilters) {
      setTablePage(1);
      get_venue_wise_collection_data();
    }
  };

  const applyFilters = () => {
    setTablePage(1);
    get_venue_wise_collection_data();
  };

  const onChangeNumberSearch = (val) => {
    setMobileNumber(val);

    if (!val) {
      setTablePage(1);
      get_venue_wise_collection_data(1, '');
    }
  };
  const onSearchCustomer = (val) => {
    if ((isNaN(val) || val.length !== 10) && val.length > 0) {
      Modal.warning({
        content: 'Please enter a valid phone number',
      });
      return;
    }

    setTablePage(1);
    get_venue_wise_collection_data(1, val);
  };

  const columns = [
    {
      title: 'Paid at',
      dataIndex: 'paid_at',
      key: 'paid_at',
      render: (text) => {
        const [date, time, ampm] = text.split(' ');

        return (
          <div>
            <div className="collist-nowrap">{date}</div>
            <div className="collist-nowrap">
              {time} {ampm}
            </div>
          </div>
        );
      },
    },
    {
      title: 'Paid for',
      dataIndex: 'paid_for',
      key: 'paid_for',
      render: (text) => <span className="collist-nowrap">{text}</span>,
    },
    {
      title: 'Customer',
      key: 'customer',
      render: (_, record) => (
        <div>
          <div className="collist-customer-name">{record.customer_name}</div>
          <div className="collist-mobile-no">{record.customer_mobile_no}</div>
        </div>
      ),
    },
    {
      title: 'Type',
      dataIndex: 'subscription',
      key: 'subscription',
      render: (item) => {
        if (item) {
          return <span style={{ fontSize: 13 }}>{item.subscription_type}</span>;
        }
        return '—';
      },
    },
    {
      title: 'Total paid',
      dataIndex: 'amount',
      key: 'amount',
      render: (value) => (value == null ? '—' : formatCurrency(value, true)),
      sorter: (a, b) => (Number(a.amount) || 0) - (Number(b.amount) || 0),
      align: 'right',
      // onHeaderCell: () => ({ className: 'collist-nowrap' }),
    },
    {
      title: 'Payment mode',
      dataIndex: 'payment_mode',
      key: 'payment_mode',
    },
    {
      title: 'Transaction ID',
      dataIndex: 'transaction_id',
      key: 'transaction_id',
      onHeaderCell: () => ({ className: 'collist-nowrap' }),
      render: (item, record) =>
        !item ? (
          // <Tag
          //   color="blue"
          //   style={{ cursor: 'pointer', padding: '4px 10px' }}
          //   onClick={() => handleModal(record, 'Add')}
          // >
          //   + Add Txn ID
          // </Tag>
          <Button type="primary" onClick={() => handleModal(record, 'Add')}>
            {' '}
            + Add Txn ID{' '}
          </Button>
        ) : (
          <div className="collist-txn-cell" onClick={() => handleModal(record, 'Edit')}>
            <span>{item.length > 5 ? item.replace(/(.{5})/g, '$1 ') : item}</span>
            <div className="collist-edit-text">
              ( <EditOutlined /> edit )
            </div>
          </div>
        ),
    },
    {
      title: 'Comment',
      dataIndex: 'comment',
      key: 'comment',
      render: (item, record) =>
        !item ? (
          <Tag
            color="orange"
            style={{ cursor: 'pointer', padding: '4px 10px' }}
            onClick={() => openCommentModal(record)}
          >
            + Add
          </Tag>
        ) : (
          // <Button type="primary" size="small" onClick={() => openCommentModal(record)}> Add </Button>
          <div className="collist-txn-cell" onClick={() => openCommentModal(record)}>
            <span>{item}</span>
            <div className="collist-edit-text">
              ( <EditOutlined /> edit )
            </div>
          </div>
        ),
    },
    {
      title: 'Status',
      key: 'status',
      dataIndex: 'status',
      render: (item, record) => (
        <>
          {item &&
            item
              .filter((tag) => tag.label !== 'transaction id missing')
              .map((tag, ind) => {
                return (
                  <div
                    key={ind}
                    onClick={() => confirmVerify(tag.label, record)}
                    className="collist-status-tag"
                    data-first={ind === 0}
                    data-clickable={tag.label === 'not verified'}
                  >
                    <Tag color={tag.color} key={tag.label}>
                      {tag.label.toUpperCase()}
                    </Tag>
                    {tag.label === 'not verified' && (
                      <div className="collist-tap-text">(Tap to change)</div>
                    )}
                  </div>
                );
              })}
        </>
      ),
    },
    {
      title: '',
      dataIndex: 'more',
      key: 'more',
      render: (item, record) => (
        <span className="collist-view-link" onClick={() => clickedARow(record)}>
          <ArrowRightOutlined className="collist-arrow-icon" />
        </span>
      ),
    },
  ];

  const clickedARow = (item) => {
    setOpenDrawer(true);
    setSelectedTableRow(item);
  };

  const confirmVerify = (label, collection) => {
    if (label === 'not verified') {
      let comment = '';
      Modal.confirm({
        title: 'Confirm',
        icon: <ExclamationCircleOutlined />,
        content: (
          <div>
            <p>Are you sure to mark this payment as verified?</p>
            <TextArea
              placeholder="Enter comment (optional)"
              onChange={(e) => {
                comment = e.target.value;
              }}
            />
          </div>
        ),
        okText: 'Yes',
        cancelText: 'No',
        onOk() {
          updateVerificationTag(collection.id, comment);
        },
      });
    }
  };

  const updateVerificationTag = async (collection_id, comment) => {
    await postData('/finance/verify_collection/', {
      collection_id: collection_id,
      comment: comment,
    })
      .then((response) => {
        if (response.success) {
          markAsVerified(collection_id);
          Modal.success({ content: response.message });
        } else {
          Modal.error({ content: response.message });
        }
      })
      .catch((error) => {
        Modal.error({
          content: error.message,
        });
      });
  };

  const markAsVerified = useCallback((collection_id) => {
    setCollectionData((prev) =>
      prev.map((item) =>
        item.id === collection_id
          ? {
              ...item,
              status: item.status.map((tag) =>
                tag.label === 'not verified' ? { ...tag, label: 'verified', color: 'green' } : tag,
              ),
            }
          : item,
      ),
    );
  }, []);

  const handleModal = (record, type) => {
    setIsModalOpen(true);
    setSelectedTableRow(record);
    setHasSearched(false);
    if (['phonepe', 'razorpay', 'razorpay_link'].includes(record.payment_mode)) {
      fetchMatchingPayments(record.id, record.transaction_id);
    }

    if (type && type === 'Edit') {
      setEditedTransactionID(record.transaction_id);
    }
    if (type && type === 'Add') {
      setMatchingPayments([]);
    }
  };

  const openCommentModal = (record) => {
    let comment = record.comment || '';
    Modal.confirm({
      title: 'Add/Edit Comment',
      content: (
        <div>
          <TextArea
            placeholder="Enter comment"
            defaultValue={comment}
            onChange={(e) => {
              comment = e.target.value;
            }}
            rows={5}
          />
        </div>
      ),
      okText: 'Submit',
      cancelText: 'Cancel',
      onOk() {
        updateComment(record.id, comment);
      },
    });
  };

  const updateComment = async (collection_id, comment) => {
    await postData('/finance/update_collection_comment/', {
      collection_id: collection_id,
      comment: comment,
    })
      .then((response) => {
        if (response.success) {
          setCollectionData((prev) =>
            prev.map((item) => (item.id === collection_id ? { ...item, comment: comment } : item)),
          );
          Modal.success({ content: response.message });
        } else {
          Modal.error({ content: response.message });
        }
      })
      .catch((error) => {
        Modal.error({ content: error.message });
      });
  };

  const getMatchingPayments = () => {
    setHasSearched(true);
    fetchMatchingPayments(selectedTableRow.id, editedTransactionID);
  };

  const fetchMatchingPayments = (collection_id, transaction_id) => {
    setLoader(true);
    getData(
      `/finance/get_matching_payment_entries/?collection_id=${collection_id}&transaction_id=${transaction_id}`,
    )
      .then((response) => {
        if (response.success) {
          setMatchingPayments(response.matching_entries);
        } else {
          Modal.error({ content: response.message });
        }
        setLoader(false);
      })
      .catch((error) => {
        setLoader(false);
        Modal.error({ content: error.message });
      });
  };

  const highlightMatch = (text, highlight) => {
    if (!highlight) return text;

    const regex = new RegExp(`(${highlight})`, 'gi');
    const parts = text.split(regex);

    return parts.map((part, index) =>
      part.toLowerCase() === highlight.toLowerCase() ? (
        <span key={index} className="collist-highlight">
          {part}
        </span>
      ) : (
        part
      ),
    );
  };

  const highlightAmount = (value, selectedAmount) => {
    if (Number(value) === Number(selectedAmount))
      return <span className="collist-highlight">{value.toLocaleString('en-IN')}</span>;

    return value.toLocaleString('en-IN');
  };

  const highlightDate = (collectedDate, paidAt) => {
    if (!collectedDate || !paidAt) return collectedDate;

    const collectedDatePart = collectedDate.split(' ')[0];
    const paidAtDatePart = paidAt.split(' ')[0];

    if (collectedDatePart === paidAtDatePart) {
      return (
        <span>
          <span className="collist-highlight">{collectedDatePart}</span>
          {' ' + collectedDate.split(' ').slice(1).join(' ')}
        </span>
      );
    }

    return collectedDate;
  };

  const verifyPhonePeRow = useCallback(
    (collection_id, phonepe_id) => {
      const selectedEntry = matchingPayments.find((entry) => entry.id === phonepe_id);
      if (!selectedEntry) {
        Modal.error({ content: 'PhonePe entry not found' });
        return;
      }
      const txnId = selectedEntry.transaction_id;

      setCollectionData((prev) =>
        prev.map((item) =>
          item.id === collection_id
            ? {
                ...item,
                transaction_id: txnId,
                status: item.status.map((tag) =>
                  tag.label === 'not verified'
                    ? { ...tag, label: 'verified', color: 'green' }
                    : tag,
                ),
              }
            : item,
        ),
      );
    },
    [matchingPayments],
  );

  const handleModalCancel = useCallback(() => {
    setIsModalOpen(false);
    setSelectedTableRow([]);
    setEditedTransactionID('');
    setUpdateTransactionIDLoader(false);
  }, []);

  const verifyPaymentEntry = useCallback(
    (collection_id, payment_instance_id) => {
      postData('/finance/verify_payment_entry/', {
        collection_id: collection_id,
        transaction_id: editedTransactionID,
        payment_instance_id: payment_instance_id,
      })
        .then((response) => {
          if (response.success) {
            if (selectedTableRow.payment_mode === 'phonepe') {
              verifyPhonePeRow(collection_id, payment_instance_id);
            } else {
              markAsVerified(collection_id);
            }
            Modal.success({ content: response.message });
            handleModalCancel();
          } else {
            Modal.error({ content: response.message });
          }
        })
        .catch((error) => {
          Modal.error({ content: error.message });
        });
    },
    [editedTransactionID, selectedTableRow, verifyPhonePeRow, markAsVerified, handleModalCancel],
  );

  const confirmPaymentVerify = useCallback(
    (collection_id, payment_instance_id) => {
      Modal.confirm({
        title: 'Are you sure?',
        content: 'Do you want to continue verifying this PhonePe collection?',
        okText: 'Yes',
        cancelText: 'No',
        onOk() {
          verifyPaymentEntry(collection_id, payment_instance_id);
        },
      });
    },
    [verifyPaymentEntry],
  );

  const phonePeColumns = useMemo(
    () => [
      {
        title: 'Collected Date',
        dataIndex: 'collected_date',
        render: (value) => highlightDate(value, selectedTableRow.paid_at),
      },
      {
        title: 'Amount',
        dataIndex: 'amount',
        render: (value) => highlightAmount(value, Math.round(selectedTableRow.amount)),
        align: 'right',
      },
      {
        title: 'Transaction ID',
        dataIndex: 'transaction_id',
        render: (value) => highlightMatch(value, editedTransactionID),
      },
      {
        title: 'UTR',
        dataIndex: 'transaction_utr',
        render: (value) => highlightMatch(value, editedTransactionID),
      },
      {
        title: 'Store Name',
        dataIndex: 'store_name',
      },
      {
        title: '',
        render: (_, record) =>
          record.processed_amount >= Math.round(record.amount) ? (
            <CheckCircleOutlined className="collist-check-icon" />
          ) : (
            <Button
              size="small"
              type="default"
              className="collist-verify-btn"
              onClick={() => confirmPaymentVerify(selectedTableRow.id, record.id)}
            >
              Verify
            </Button>
          ),
      },
    ],
    [
      selectedTableRow.paid_at,
      selectedTableRow.amount,
      selectedTableRow.id,
      editedTransactionID,
      confirmPaymentVerify,
    ],
  );

  const razorpayColumns = useMemo(
    () => [
      {
        title: 'Collected Date',
        dataIndex: 'created_at',
        render: (value) => highlightDate(value, selectedTableRow.paid_at),
      },
      {
        title: 'Contact',
        dataIndex: 'contact',
        render: (value) => highlightMatch(value, selectedTableRow.customer_mobile_no),
      },
      {
        title: 'Amount',
        dataIndex: 'amount',
        align: 'right',
        render: (value, record) => (
          <div>
            <div>
              {highlightAmount(
                Math.round(record.amount - (record.fee || 0)),
                Math.round(selectedTableRow.amount - (selectedTableRow.fee || 0)),
              )}
            </div>

            {record.fee ? (
              <div style={{ fontSize: 12, color: '#888' }}>+ {Math.round(record.fee)} (fee)</div>
            ) : null}
          </div>
        ),
      },
      {
        title: 'Mode',
        dataIndex: 'mode_of_payment',
      },
      {
        title: 'Payment ID',
        dataIndex: 'payment_id',
        render: (value) => highlightMatch(value, editedTransactionID),
      },
      {
        title: 'Order ID',
        dataIndex: 'order_id',
        render: (value) => highlightMatch(value, editedTransactionID),
      },
      {
        title: '',
        render: (_, record) =>
          record.collection_id === selectedTableRow.id ? (
            <span>Tagged to selected collection</span>
          ) : record.collection_id ? (
            <span>Tagged to another collection</span>
          ) : (
            <Button
              size="small"
              type="default"
              style={{
                color: '#1890ff',
                borderColor: '#1890ff',
              }}
              onClick={() => confirmPaymentVerify(selectedTableRow.id, record.id)}
            >
              Verify
            </Button>
          ),
      },
    ],
    [
      selectedTableRow.paid_at,
      selectedTableRow.customer_mobile_no,
      selectedTableRow.amount,
      selectedTableRow.fee,
      selectedTableRow.id,
      editedTransactionID,
      confirmPaymentVerify,
    ],
  );

  const updateTransactionID = () => {
    if (editedTransactionID) {
      postTransactionID();
    } else {
      Modal.warning({ content: 'Please enter the transaction id' });
    }
  };

  const postTransactionID = async () => {
    setUpdateTransactionIDLoader(true);
    await postData('/finance/update_transaction_id/', {
      collection_id: selectedTableRow.id,
      transaction_id: editedTransactionID,
    })
      .then((response) => {
        if (response.success === true) {
          updateTxnId(selectedTableRow.id, editedTransactionID);
          handleModalCancel();
          Modal.success({ content: response.message });
        } else {
          Modal.error({ content: response.message });
        }
      })
      .catch((error) => {
        handleModalCancel();
        Modal.error({ content: error.message });
      });
  };

  const updateTxnId = (collection_id, txnId) => {
    setCollectionData((prev) =>
      prev.map((item) => (item.id === collection_id ? { ...item, transaction_id: txnId } : item)),
    );
  };

  const drawerFields = [
    { label: 'Name', key: 'customer_name' },
    { label: 'Mobile Number', key: 'customer_mobile_no' },
    { label: 'Venue', key: 'venue' },
    { label: 'Location', key: 'location' },
    { label: 'City', key: 'city' },
    {
      label: 'Total Paid',
      render: (data) => data?.amount?.toLocaleString('en-IN'),
    },
    { label: 'Paid At', key: 'paid_at' },
    { label: 'Paid For', key: 'paid_for' },
    { label: 'Payment Mode', key: 'payment_mode' },
    { label: 'Payment Source', key: 'payment_source' },
    { label: 'Transaction ID', key: 'transaction_id' },

    {
      label: 'Attachment',
      render: (data) =>
        data?.payment_attachment ? (
          <a href={data.payment_attachment} target="_blank" rel="noreferrer">
            Click to view
          </a>
        ) : null,
    },

    { label: 'Comment', key: 'comment', hideIfEmpty: true },

    {
      label: 'Package',
      render: (data) => data?.subscription?.package,
    },
    {
      label: 'Type',
      render: (data) => data?.subscription?.subscription_type,
    },
    {
      label: 'Collected By',
      key: 'collected_by',
      hideIfEmpty: true,
    },
    {
      label: 'Subsc. Status',
      render: (data) => data?.subscription?.status,
    },
    {
      label: 'Verification Comment',
      render: (data) => data?.verification_details?.comment,
      hideIfEmpty: true,
    },
    {
      label: 'Verified By',
      render: (data) => data?.verification_details?.verified_by,
      hideIfEmpty: true,
    },
    {
      label: 'Payment ID (Razorpay)',
      render: (data) => data?.verification_details?.razorpay?.payment_id,
      hideIfEmpty: true,
    },
  ];

  return (
    <div className="collist-root">
      <PageHeader title="Collection Verification" hasBackButton={true}>
        {!tableLoader && (
          <Tag color="blue" className="collist-header-tag">
            {'Venue: ' + venueName}
          </Tag>
        )}
        <Tag color="blue" className="collist-header-tag">
          {'Month: ' + formatted}
        </Tag>
      </PageHeader>

      <div className="collist-card">
        <CollectionToolbar
          filterOptions={filterOptions}
          appliedFilters={appliedFilters}
          onChangeFilter={onChangeFilter}
          onApplyFilters={applyFilters}
          filterCascader={filterCascader}
          mobileNumber={mobileNumber}
          onSearchCustomer={onSearchCustomer}
          onChangeNumberSearch={onChangeNumberSearch}
          sortSelector={sortSelector}
          setSortSelector={setSortSelector}
          totalEntries={totalEntries}
          tableLoader={tableLoader}
        />

        <Table
          className="collection-custom-table collist-table"
          columns={columns}
          dataSource={collectionData}
          scroll={{ x: true }}
          loading={tableLoader}
          onChange={onChangePage}
          pagination={{
            current: tablePage,
            total: totalEntries,
            pageSize: tablePageSize,
            showSizeChanger: false,
          }}
        />
      </div>

      <DetailsDrawer
        open={openDrawer}
        onClose={() => setOpenDrawer(false)}
        title="Collection Details"
        data={selectedTableRow}
        fields={drawerFields}
        extraActions={(data) =>
          data?.invoice_link && (
            <div className="collist-actions-row">
              <a
                href={data.invoice_link}
                target="_blank"
                rel="noopener noreferrer"
                className="collist-flex-1"
              >
                <Button type="primary" className="collist-full-width">
                  View Invoice
                </Button>
              </a>
              <Button type="primary-outlined" className="collist-flex-1" onClick={handleViewLogs}>
                View Logs
              </Button>
            </div>
          )
        }
      />

      <Modal
        title="Subscription Change History"
        open={logsModalOpen}
        onCancel={() => setLogsModalOpen(false)}
        footer={null}
        width={950}
        wrapClassName="subscription-change-modal"
      >
        {logsLoading ? (
          <div className="collist-centered-text">Loading...</div>
        ) : logsData.length === 0 ? (
          <div className="collist-centered-text">No logs found.</div>
        ) : (
          <Table
            dataSource={logsData}
            columns={logsColumns}
            rowKey={(record) => record.id || `${record.edited_date}-${record.change_type}`}
            pagination={logsData.length > 10 ? { pageSize: 10 } : false}
            size="small"
            bordered
            scroll={{ x: 900, y: 420 }}
          />
        )}
      </Modal>

      <Modal
        title="Update Transaction ID"
        open={isModalOpen}
        closable={true}
        width={1000}
        onCancel={handleModalCancel}
        footer={
          !['phonepe', 'razorpay', 'razorpay_link'].includes(selectedTableRow.payment_mode) && [
            <Button key="back" onClick={handleModalCancel}>
              Cancel
            </Button>,
            <Button
              key="submit"
              type="primary"
              onClick={updateTransactionID}
              loading={updateTransactionIDLoader}
            >
              Submit
            </Button>,
          ]
        }
      >
        <p className="collist-modal-desc">
          {selectedTableRow.customer_name && selectedTableRow.customer_name + '- '}{' '}
          {selectedTableRow.customer_mobile_no} paid{' '}
          <span className="collist-text-bold">
            {Math.round(selectedTableRow.amount)?.toLocaleString('en-IN')}
          </span>{' '}
          at <span className="collist-text-bold">{selectedTableRow.venue}</span> on{' '}
          <span className="collist-text-bold">{selectedTableRow.paid_at}</span>
        </p>

        {!['phonepe', 'razorpay', 'razorpay_link'].includes(selectedTableRow.payment_mode) ? (
          <Input
            ref={inputRef}
            autoFocus
            placeholder="enter transaction id"
            value={editedTransactionID}
            onChange={(e) => setEditedTransactionID(e.target.value)}
          />
        ) : (
          <>
            <div className="collist-txn-header-row">
              <div className="collist-txn-label">Transaction ID</div>

              <div className="collist-txn-input-row">
                <Input
                  ref={inputRef}
                  autoFocus
                  placeholder="Enter transaction ID"
                  value={editedTransactionID}
                  onChange={(e) => setEditedTransactionID(e.target.value)}
                />

                <Button type="default" loading={loader} onClick={getMatchingPayments}>
                  Search
                </Button>

                <Button type="primary" onClick={updateTransactionID}>
                  Save
                </Button>
              </div>
            </div>

            {loader ? (
              <p style={{ fontSize: 13, fontWeight: 500, marginBottom: 10 }}>
                Checking for possible matching payments...
              </p>
            ) : matchingPayments.length > 0 ? (
              <div style={{ maxWidth: '100%', overflowX: 'auto' }}>
                <p style={{ fontSize: 14, fontWeight: 500, marginBottom: 10, color: '#389e0d' }}>
                  Possible Matching payments found for this payment
                </p>

                <Table
                  dataSource={matchingPayments}
                  columns={
                    selectedTableRow.payment_mode === 'phonepe' ? phonePeColumns : razorpayColumns
                  }
                  pagination={matchingPayments.length > 5 ? { pageSize: 5 } : false}
                  bordered
                  rowKey="id"
                  rowClassName={(record) => {
                    if (
                      ['razorpay', 'razorpay_link'].includes(selectedTableRow.payment_mode) &&
                      record.collection_id === selectedTableRow.id
                    ) {
                      return 'highlight-row-green';
                    }
                    return '';
                  }}
                />

                {/* {['razorpay', 'razorpay_link'].includes(selectedTableRow.payment_mode) && (
                    <p style={{ fontSize: 12, marginBottom: 10, color: "#595959" , display: 'flex', alignItems: 'center'}}>
                      <span
                        style={{
                          display: "inline-block",
                          width: 12,
                          height: 12,
                          backgroundColor: "#aff16d",
                          marginRight: 6,
                          verticalAlign: "middle",
                        }}
                      />
                      Green row indicates the currently tagged payment
                    </p>
                  )} */}
              </div>
            ) : (
              hasSearched && (
                <p style={{ fontSize: 13, fontWeight: 500, marginBottom: 10, color: '#cf1322' }}>
                  No possible matching payments found for this transaction ID
                </p>
              )
            )}
          </>
        )}
      </Modal>
    </div>
  );
}

export default CollectionVerification;
